(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brazilian-butt-boost-cards"]) return;
  try {
    
  document.querySelectorAll(".cart-form input[name='id']").forEach(val => {
    val.addEventListener("change", function(e) {
        document.querySelector(".btn--addToCart").click()
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breast-max-plus-cards"]) return;
  try {
    
  var tab_nav1 = $('.nav-tab1') // tab nav
var tab_content1 = $('.content1') // tab content

// Dynamic classes
tab_content1.each(function (i) {
  $(this).attr('id', 'tab1-' + i);
})
tab_nav1.children('li').children('a').each(function (i) {
  $(this).attr('href', '#tab1-' + i)
})

// Show first tab
tab_nav1.children('li:first-of-type').addClass('active');
tab_content1.hide();
tab_content1.first().show();

// Click function
tab_nav1.children('li').children('a').on('click', function (e) {
e.preventDefault();
  tab_nav1.children('li').removeClass('active');
  $(this).parent().addClass('active');
  var activeTab1 = $(this).attr('href');

  $(activeTab1).siblings().hide().removeClass("active");
  $(activeTab1).fadeIn().addClass("active")
});


  document.querySelectorAll(".cart-form input[name='id']").forEach(val => {
    val.addEventListener("change", function(e) {
        document.querySelector(".btn--addToCart").click()
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["butt-product-section"]) return;
  try {
    
  var swiper = new Swiper(".mySwiper", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  var swiper2 = new Swiper(".mySwiper2", {
    autoHeight: true,
    spaceBetween: 10,
    thumbs: {
      swiper: swiper,
    },
  });

  document.querySelectorAll(".single-product-hero input[name='id' data-productid='{{ product.id }}']").forEach(val => {
    val.addEventListener("change", function(e) {
        document.querySelector(".btn--addToCart").click()
    })
  })

  $('.Purchase.sold-out label').on('click' , function(e){
    e.preventDefault();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-breast"]) return;
  try {
    
  var questionFAQ = jQuery(".faqs .accordion__header"); // accordion opener
  var answerFAQ = jQuery(".faqs .accordion__body"); // accordion content

  answerFAQ.hide();

  questionFAQ.click(function () {
    answerFAQ.slideUp();
    if (jQuery(this).hasClass("open")) {
      jQuery(this).removeClass("open").next(answerFAQ).slideUp();
    } else {
      questionFAQ.removeClass("open");
      jQuery(this).addClass("open").next(answerFAQ).slideDown();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  var questionFAQ = jQuery(".faqs .accordion__header"); // accordion opener
  var answerFAQ = jQuery(".faqs .accordion__body"); // accordion content

  answerFAQ.hide();

  questionFAQ.click(function () {
    answerFAQ.slideUp();
    if (jQuery(this).hasClass("open")) {
      jQuery(this).removeClass("open").next(answerFAQ).slideUp();
    } else {
      questionFAQ.removeClass("open");
      jQuery(this).addClass("open").next(answerFAQ).slideDown();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-breast"]) return;
  try {
    

// function startCountdown() {
//   // Set the target date and tim
//   var targetDate = new Date("November 30, 2023 23:59:59").getTime();
  
//   // Calculate the end time by adding 50 hours (50 * 60 * 60 * 1000 milliseconds) to the target date
//   var endTime = targetDate + (50 * 60 * 60 * 1000);
  
//   // Update the countdown every second
//   var countdownInterval = setInterval(function() {
//     var now = new Date().getTime();
//     var distance = targetDate - now;
    
//     if (distance < 0) {
//       clearInterval(countdownInterval);
//       document.getElementById("countdown").innerHTML = "Countdown expired!!";
//     } else {
//       var days = Math.floor(distance / (1000 * 60 * 60 * 24));
//       var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       var seconds = Math.floor((distance % (1000 * 60)) / 1000);

//       document.getElementById("days").innerHTML = days + "<span>days</span>";
//       document.getElementById("hours").innerHTML = hours + "<span>hours</span>";
//       document.getElementById("minutes").innerHTML = minutes + "<span>minutes</span>";
//       document.getElementById("seconds").innerHTML = seconds + "<span>seconds</span>";
//     }
//   }, 1000);
// } 

  
//   startCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-butt"]) return;
  try {
    

// function startCountdown() {
//   // Set the target date and tim
//   var targetDate = new Date("November 30, 2023 23:59:59").getTime();
  
//   // Calculate the end time by adding 50 hours (50 * 60 * 60 * 1000 milliseconds) to the target date
//   var endTime = targetDate + (50 * 60 * 60 * 1000);
  
//   // Update the countdown every second
//   var countdownInterval = setInterval(function() {
//     var now = new Date().getTime();
//     var distance = targetDate - now;
    
//     if (distance < 0) {
//       clearInterval(countdownInterval);
//       document.getElementById("countdown").innerHTML = "Countdown expired!!";
//     } else {
//       var days = Math.floor(distance / (1000 * 60 * 60 * 24));
//       var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       var seconds = Math.floor((distance % (1000 * 60)) / 1000);

//       document.getElementById("days").innerHTML = days + "<span>days</span>";
//       document.getElementById("hours").innerHTML = hours + "<span>hours</span>";
//       document.getElementById("minutes").innerHTML = minutes + "<span>minutes</span>";
//       document.getElementById("seconds").innerHTML = seconds + "<span>seconds</span>";
//     }
//   }, 1000);
// } 
  
//   startCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale"]) return;
  try {
    

// function startCountdown() {
//   // Set the target date and time
//   var targetDate = new Date("August 18, 2023 10:00:00").getTime();
  
//   // Calculate the end time by adding 50 hours (50 * 60 * 60 * 1000 milliseconds) to the target date
//   var endTime = targetDate + (50 * 60 * 60 * 1000);
  
//   // Update the countdown every second
//   var countdownInterval = setInterval(function() {
//     var now = new Date().getTime();
//     var distance = endTime - now;
    
//     if (distance < 0) {
//       clearInterval(countdownInterval);
//       document.getElementById("countdown").innerHTML = "Countdown expired!!";
//     } else {
//       var hours = Math.floor(distance / (1000 * 60 * 60));
//       var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
//       document.getElementById("hours").innerHTML = hours + "<span>hours</span>";
//       document.getElementById("minutes").innerHTML = minutes + "<span>minutes</span>";
//       document.getElementById("seconds").innerHTML = seconds + "<span>seconds</span>";
//     }
//   }, 1000);
// } 
  
//   startCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guide"]) return;
  try {
    
const myInterval = setInterval(function(){ 
console.log('interval')
let el = jQuery('.section-form-text-1 .klaviyo-form form button[type="button"]');
if(el.length === 1){
jQuery('.section-form-text-1 .klaviyo-form form button[type="button"]').on('click', function(){
    setTimeout(function() { 
        if ( jQuery('.section-form-text-1 .klaviyo-form span[role="alert"]').length === 0) {
            document.cookie = "guide=1";
        }
    }, 2000);
})
clearInterval();
} 
}, 1000);


  
if($.cookie('guide')) {
    jQuery('.section-form-text-1').css('display','none');
  clearInterval(myInterval);
}

  
  var questionFAQ = jQuery(".toc .accordion__header"); // accordion opener
  var answerFAQ = jQuery(".toc .accordion__body"); // accordion content

  answerFAQ.hide();

  questionFAQ.click(function () {
    answerFAQ.slideUp();
    if (jQuery(this).hasClass("open")) {
      jQuery(this).removeClass("open").next(answerFAQ).slideUp();
    } else {
      questionFAQ.removeClass("open");
      jQuery(this).addClass("open").next(answerFAQ).slideDown();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-work-breast-bundle"]) return;
  try {
    
   var tab_nav = jQuery('.landing-how-it-works .nav-tab') // tab nav
  var tab_content = jQuery('.landing-how-it-works .content') // tab content
  
  // Dynamic classes
  tab_content.each(function (i) {
    jQuery(this).attr('id', 'tab-acc-' + i);
  })
  tab_nav.children('li').children('a').each(function (i) {
    jQuery(this).attr('data-target', '#tab-acc-' + i)
  })
  
  // Show first tab
  tab_content.hide();
  tab_content.first().show();
  tab_nav.children('li').first().addClass("active")
  tab_content.first().addClass("active")
  
  // Click function
  tab_nav.children('li').children('a').on('click', function () {
    tab_nav.children('li').removeClass('active');
    jQuery(this).parent().addClass('active');
    var activeTab = jQuery(this).attr('data-target');
  
    console.log(jQuery(activeTab))
    jQuery(activeTab).siblings().hide().removeClass("active");
    jQuery(activeTab).fadeIn().addClass("active")
  });

$(document).ready(function(){
  var $question = $(".works__header"); // accordion opener
var $answer = $(".works__body"); // accordion content

$answer.hide();

$question.click(function () {
  $answer.slideUp();
  if ($(this).hasClass("open")) {
    $(this).removeClass("open").next($answer).slideUp();
  } else {
    $question.removeClass("open");
    $(this).addClass("open").next($answer).slideDown();
  }
});
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-brazilian"]) return;
  try {
    
  var tab_nav = jQuery('.landing-how-it-works .nav-tab') // tab nav
  var tab_content = jQuery('.landing-how-it-works .content') // tab content
  
  // Dynamic classes
  tab_content.each(function (i) {
    jQuery(this).attr('id', 'tab-acc-' + i);
  })
  tab_nav.children('li').children('a').each(function (i) {
    jQuery(this).attr('data-target', '#tab-acc-' + i)
  })
  
  // Show first tab
  tab_content.hide();
  tab_content.first().show();
  tab_nav.children('li').first().addClass("active")
  tab_content.first().addClass("active")
  
  // Click function
  tab_nav.children('li').children('a').on('click', function () {
    tab_nav.children('li').removeClass('active');
    jQuery(this).parent().addClass('active');
    var activeTab = jQuery(this).attr('data-target');
  
    console.log(jQuery(activeTab))
    jQuery(activeTab).siblings().hide().removeClass("active");
    jQuery(activeTab).fadeIn().addClass("active")
  });

$(document).ready(function(){
  var $question = $(".works__header"); // accordion opener
  var $answer = $(".works__body"); // accordion content
  
  $answer.hide();
  
  $question.click(function () {
    $answer.slideUp();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open").next($answer).slideUp();
    } else {
      $question.removeClass("open");
      $(this).addClass("open").next($answer).slideDown();
    }
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-lipmax"]) return;
  try {
    
  var tab_nav = jQuery('.landing-how-it-works .nav-tab') // tab nav
  var tab_content = jQuery('.landing-how-it-works .content') // tab content
  
  // Dynamic classes
  tab_content.each(function (i) {
    jQuery(this).attr('id', 'tab-acc-' + i);
  })
  tab_nav.children('li').children('a').each(function (i) {
    jQuery(this).attr('data-target', '#tab-acc-' + i)
  })
  
  // Show first tab
  tab_content.hide();
  tab_content.first().show();
  tab_nav.children('li').first().addClass("active")
  tab_content.first().addClass("active")
  
  // Click function
  tab_nav.children('li').children('a').on('click', function () {
    tab_nav.children('li').removeClass('active');
    jQuery(this).parent().addClass('active');
    var activeTab = jQuery(this).attr('data-target');
  
    console.log(jQuery(activeTab))
    jQuery(activeTab).siblings().hide().removeClass("active");
    jQuery(activeTab).fadeIn().addClass("active")
  });

  $(document).ready(function(){
  var $question = $(".accordion__header"); // accordion opener
var $answer = $(".accordion__body"); // accordion content

$answer.hide();

$question.click(function () {
  $answer.slideUp();
  if ($(this).hasClass("open")) {
    $(this).removeClass("open").next($answer).slideUp();
  } else {
    $question.removeClass("open");
    $(this).addClass("open").next($answer).slideDown();
  }
});
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"]) return;
  try {
    
   var tab_nav = jQuery('.landing-how-it-works .nav-tab') // tab nav
  var tab_content = jQuery('.landing-how-it-works .content') // tab content
  
  // Dynamic classes
  tab_content.each(function (i) {
    jQuery(this).attr('id', 'tab-acc-' + i);
  })
  tab_nav.children('li').children('a').each(function (i) {
    jQuery(this).attr('data-target', '#tab-acc-' + i)
  })
  
  // Show first tab
  tab_content.hide();
  tab_content.first().show();
  tab_nav.children('li').first().addClass("active")
  tab_content.first().addClass("active")
  
  // Click function
  tab_nav.children('li').children('a').on('click', function () {
    tab_nav.children('li').removeClass('active');
    jQuery(this).parent().addClass('active');
    var activeTab = jQuery(this).attr('data-target');
  
    console.log(jQuery(activeTab))
    jQuery(activeTab).siblings().hide().removeClass("active");
    jQuery(activeTab).fadeIn().addClass("active")
  });

$(document).ready(function(){
  var $question = $(".works__header"); // accordion opener
var $answer = $(".works__body"); // accordion content

$answer.hide();

$question.click(function () {
  $answer.slideUp();
  if ($(this).hasClass("open")) {
    $(this).removeClass("open").next($answer).slideUp();
  } else {
    $question.removeClass("open");
    $(this).addClass("open").next($answer).slideDown();
  }
});
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-works-single-besty-booty"]) return;
  try {
    
  var tab_nav = jQuery('.landing-how-it-works .nav-tab') // tab nav
  var tab_content = jQuery('.landing-how-it-works .content') // tab content
  
  // Dynamic classes
  tab_content.each(function (i) {
    jQuery(this).attr('id', 'tab-acc-' + i);
  })
  tab_nav.children('li').children('a').each(function (i) {
    jQuery(this).attr('data-target', '#tab-acc-' + i)
  })
  
  // Show first tab
  tab_content.hide();
  tab_content.first().show();
  tab_nav.children('li').first().addClass("active")
  tab_content.first().addClass("active")
  
  // Click function
  tab_nav.children('li').children('a').on('click', function () {
    tab_nav.children('li').removeClass('active');
    jQuery(this).parent().addClass('active');
    var activeTab = jQuery(this).attr('data-target');
  
    console.log(jQuery(activeTab))
    jQuery(activeTab).siblings().hide().removeClass("active");
    jQuery(activeTab).fadeIn().addClass("active")
  });

$(document).ready(function(){
  var $question = $(".works__header"); // accordion opener
  var $answer = $(".works__body"); // accordion content
  
  $answer.hide();
  
  $question.click(function () {
    $answer.slideUp();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open").next($answer).slideUp();
    } else {
      $question.removeClass("open");
      $(this).addClass("open").next($answer).slideDown();
    }
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-works-single-bigger-bum"]) return;
  try {
    
  var tab_nav = jQuery('.landing-how-it-works .nav-tab') // tab nav
  var tab_content = jQuery('.landing-how-it-works .content') // tab content
  
  // Dynamic classes
  tab_content.each(function (i) {
    jQuery(this).attr('id', 'tab-acc-' + i);
  })
  tab_nav.children('li').children('a').each(function (i) {
    jQuery(this).attr('data-target', '#tab-acc-' + i)
  })
  
  // Show first tab
  tab_content.hide();
  tab_content.first().show();
  tab_nav.children('li').first().addClass("active")
  tab_content.first().addClass("active")
  
  // Click function
  tab_nav.children('li').children('a').on('click', function () {
    tab_nav.children('li').removeClass('active');
    jQuery(this).parent().addClass('active');
    var activeTab = jQuery(this).attr('data-target');
  
    console.log(jQuery(activeTab))
    jQuery(activeTab).siblings().hide().removeClass("active");
    jQuery(activeTab).fadeIn().addClass("active")
  });

$(document).ready(function(){
  var $question = $(".works__header"); // accordion opener
  var $answer = $(".works__body"); // accordion content
  
  $answer.hide();
  
  $question.click(function () {
    $answer.slideUp();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open").next($answer).slideUp();
    } else {
      $question.removeClass("open");
      $(this).addClass("open").next($answer).slideDown();
    }
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-works-single-brazilian-butt-boost-cream"]) return;
  try {
    
  var tab_nav = jQuery('.landing-how-it-works .nav-tab') // tab nav
  var tab_content = jQuery('.landing-how-it-works .content') // tab content
  
  // Dynamic classes
  tab_content.each(function (i) {
    jQuery(this).attr('id', 'tab-acc-' + i);
  })
  tab_nav.children('li').children('a').each(function (i) {
    jQuery(this).attr('data-target', '#tab-acc-' + i)
  })
  
  // Show first tab
  tab_content.hide();
  tab_content.first().show();
  tab_nav.children('li').first().addClass("active")
  tab_content.first().addClass("active")
  
  // Click function
  tab_nav.children('li').children('a').on('click', function () {
    tab_nav.children('li').removeClass('active');
    jQuery(this).parent().addClass('active');
    var activeTab = jQuery(this).attr('data-target');
  
    console.log(jQuery(activeTab))
    jQuery(activeTab).siblings().hide().removeClass("active");
    jQuery(activeTab).fadeIn().addClass("active")
  });

$(document).ready(function(){
  var $question = $(".works__header"); // accordion opener
  var $answer = $(".works__body"); // accordion content
  
  $answer.hide();
  
  $question.click(function () {
    $answer.slideUp();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open").next($answer).slideUp();
    } else {
      $question.removeClass("open");
      $(this).addClass("open").next($answer).slideDown();
    }
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-works-single-butt-bundle"]) return;
  try {
    
  var tab_nav = jQuery('.landing-how-it-works .nav-tab') // tab nav
  var tab_content = jQuery('.landing-how-it-works .content') // tab content
  
  // Dynamic classes
  tab_content.each(function (i) {
    jQuery(this).attr('id', 'tab-acc-' + i);
  })
  tab_nav.children('li').children('a').each(function (i) {
    jQuery(this).attr('data-target', '#tab-acc-' + i)
  })
  
  // Show first tab
  tab_content.hide();
  tab_content.first().show();
  tab_nav.children('li').first().addClass("active")
  tab_content.first().addClass("active")
  
  // Click function
  tab_nav.children('li').children('a').on('click', function () {
    tab_nav.children('li').removeClass('active');
    jQuery(this).parent().addClass('active');
    var activeTab = jQuery(this).attr('data-target');
  
    console.log(jQuery(activeTab))
    jQuery(activeTab).siblings().hide().removeClass("active");
    jQuery(activeTab).fadeIn().addClass("active")
  });

$(document).ready(function(){
  var $question = $(".works__header"); // accordion opener
  var $answer = $(".works__body"); // accordion content
  
  $answer.hide();
  
  $question.click(function () {
    $answer.slideUp();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open").next($answer).slideUp();
    } else {
      $question.removeClass("open");
      $(this).addClass("open").next($answer).slideDown();
    }
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-works-single-butt"]) return;
  try {
    
  var tab_nav = jQuery('.landing-how-it-works .nav-tab') // tab nav
  var tab_content = jQuery('.landing-how-it-works .content') // tab content
  
  // Dynamic classes
  tab_content.each(function (i) {
    jQuery(this).attr('id', 'tab-acc-' + i);
  })
  tab_nav.children('li').children('a').each(function (i) {
    jQuery(this).attr('data-target', '#tab-acc-' + i)
  })
  
  // Show first tab
  tab_content.hide();
  tab_content.first().show();
  tab_nav.children('li').first().addClass("active")
  tab_content.first().addClass("active")
  
  // Click function
  tab_nav.children('li').children('a').on('click', function () {
    tab_nav.children('li').removeClass('active');
    jQuery(this).parent().addClass('active');
    var activeTab = jQuery(this).attr('data-target');
  
    console.log(jQuery(activeTab))
    jQuery(activeTab).siblings().hide().removeClass("active");
    jQuery(activeTab).fadeIn().addClass("active")
  });

$(document).ready(function(){
  var $question = $(".works__header"); // accordion opener
  var $answer = $(".works__body"); // accordion content
  
  $answer.hide();
  
  $question.click(function () {
    $answer.slideUp();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open").next($answer).slideUp();
    } else {
      $question.removeClass("open");
      $(this).addClass("open").next($answer).slideDown();
    }
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-works-single-curvy"]) return;
  try {
    
  var tab_nav = jQuery('.landing-how-it-works .nav-tab') // tab nav
  var tab_content = jQuery('.landing-how-it-works .content') // tab content
  
  // Dynamic classes
  tab_content.each(function (i) {
    jQuery(this).attr('id', 'tab-acc-' + i);
  })
  tab_nav.children('li').children('a').each(function (i) {
    jQuery(this).attr('data-target', '#tab-acc-' + i)
  })
  
  // Show first tab
  tab_content.hide();
  tab_content.first().show();
  tab_nav.children('li').first().addClass("active")
  tab_content.first().addClass("active")
  
  // Click function
  tab_nav.children('li').children('a').on('click', function () {
    tab_nav.children('li').removeClass('active');
    jQuery(this).parent().addClass('active');
    var activeTab = jQuery(this).attr('data-target');
  
    console.log(jQuery(activeTab))
    jQuery(activeTab).siblings().hide().removeClass("active");
    jQuery(activeTab).fadeIn().addClass("active")
  });

$(document).ready(function(){
  var $question = $(".works__header"); // accordion opener
  var $answer = $(".works__body"); // accordion content
  
  $answer.hide();
  
  $question.click(function () {
    $answer.slideUp();
    if ($(this).hasClass("open")) {
      $(this).removeClass("open").next($answer).slideUp();
    } else {
      $question.removeClass("open");
      $(this).addClass("open").next($answer).slideDown();
    }
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["join-script"]) return;
  try {
    
$(window).on('load', function() {
    window.location.href = "sms://+18449252783?&body=JOIN"
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  var question = jQuery(".product-content .accordion__header"); // accordion opener
  var answer = jQuery(".product-content .accordion__body"); // accordion content

  answer.hide();

  question.click(function () {
    answer.slideUp();
    if (jQuery(this).hasClass("open")) {
      jQuery(this).removeClass("open").next(answer).slideUp();
    } else {
      question.removeClass("open");
      jQuery(this).addClass("open").next(answer).slideDown();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-loop-breast-landing"]) return;
  try {
    
  jQuery(document).ready(function(){
  jQuery(".template-product .product-card h3").each(function(){
    if(jQuery(this).text() == jQuery('.single-product-hero__title').text()){
        jQuery(this).closest('.product-loop__item').remove()
    }
})
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-loop-bundles"]) return;
  try {
    
  jQuery(document).ready(function(){
  jQuery(".template-product .product-card h3").each(function(){
    if(jQuery(this).text() == jQuery('.single-product-hero__title').text()){
        jQuery(this).closest('.product-loop__item').remove()
    }
})
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-loop"]) return;
  try {
    
  jQuery(document).ready(function(){
  jQuery(".template-product .product-card h3").each(function(){
    if(jQuery(this).text() == jQuery('.single-product-hero__title').text()){
        jQuery(this).closest('.product-loop__item').remove()
    }
})
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-suggested-loop"]) return;
  try {
    
  jQuery(document).ready(function(){
  jQuery(".template-product .product-card h3").each(function(){
    if(jQuery(this).text() == jQuery('.single-product-hero__title').text()){
        jQuery(this).closest('.product-loop__item').remove()
    }
})
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-hero"]) return;
  try {
    
     jQuery(document).on('click','.video-overlay',function(e) {
    jQuery(this).remove();             
});

  
  var video = document.querySelector(".video"),
  button = document.querySelector(".video-overlay");


button.addEventListener("click", function() {
  video.play()
    //video.setAttribute("autoplay","autoplay")// this will set the attribute but will not play 
}, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-main-product-flash-sale"]) return;
  try {
    

// function startCountdown() {
//   // Set the target date and ti
//   var targetDate = new Date("November 30, 2023 23:59:59").getTime();
  
//   // Calculate the end time by adding 50 hours (50 * 60 * 60 * 1000 milliseconds) to the target date
//   var endTime = targetDate + (50 * 60 * 60 * 1000);
  
//   // Update the countdown every second
//   var countdownInterval = setInterval(function() {
//     var now = new Date().getTime();
//     var distance = targetDate - now;
    
//     if (distance < 0) {
//       clearInterval(countdownInterval);
//       document.getElementById("countdown").innerHTML = "Countdown expired!!";
//     } else {
//       var days = Math.floor(distance / (1000 * 60 * 60 * 24));
//       var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       var seconds = Math.floor((distance % (1000 * 60)) / 1000);

//       document.getElementById("days").innerHTML = days + "<span>days</span>";
//       document.getElementById("hours").innerHTML = hours + "<span>hours</span>";
//       document.getElementById("minutes").innerHTML = minutes + "<span>minutes</span>";
//       document.getElementById("seconds").innerHTML = seconds + "<span>seconds</span>";
//     }
//   }, 1000);
// }  
  
//   startCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product-hero-bundle"]) return;
  try {
    
  var swiper = new Swiper(".mySwiper", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  var swiper = new Swiper(".mySwiper2", {
    autoHeight: true,
    spaceBetween: 10,
    thumbs: {
      swiper: swiper,
    },
  });


  document.querySelectorAll(".single-product-hero input[name='id']").forEach(val => {
    val.addEventListener("change", function(e) {
      console.log('change');
        document.querySelector(".btn--addToCart").click()
      jQuery(this).prop('checked', false);
      setTimeout(function(){
     	document.querySelector(".header-middle__item--cart span").click()
      }, 1000);
        
    })
  })

  $('.Purchase.sold-out label').on('click' , function(e){
    e.preventDefault();
})

var intervalId = setInterval(function() {
  if ($('.rc-template__button-group').length > 0) {
    clearInterval(intervalId);
    $('.rc-option__subsave').on('click',function(){
        console.log('usama')
        if($('.purchase-main').hasClass('subsave')) {
            var orgPrice = parseFloat($('.purchase-main.subsave .save-10 .price-custom').text().split('$')[1]);
            var disPrice = parseFloat($('.purchase-main.subsave .save-10 .price-custom').text().split('$')[1]) * 20 / 100;
            var price = orgPrice - disPrice;
            $('.purchase-main.subsave .save-10 .price-custom').attr('data-sub', price.toFixed(2));
        }
    })
  }
}, 1000);
  

    $(window).on('load',function(){
      console.log('luffy');
      setTimeout(function() {
        $('.rc_popup').addClass('none');
        $('.rc-option__onetime').on('click',function(){
            $('.rc_popup').addClass('none');
        })
        
        $('.rc-option__subsave').on('click',function(){
            $('.rc_popup').removeClass('none');
        })
      }, 1000)
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product-hero"]) return;
  try {
    
  var swiper = new Swiper(".mySwiper", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  var swiper = new Swiper(".mySwiper2", {
    autoHeight: true,
    spaceBetween: 10,
    thumbs: {
      swiper: swiper,
    },
  });


  document.querySelectorAll(".single-product-hero input[name='id']").forEach(val => {
    val.addEventListener("change", function(e) {
      console.log('change');
        document.querySelector(".btn--addToCart").click()
      jQuery(this).prop('checked', false);
      setTimeout(function(){
     	document.querySelector(".header-middle__item--cart span").click()
      }, 1000);
        
    })
  })

  $('.Purchase.sold-out label').on('click' , function(e){
    e.preventDefault();
})

var intervalId = setInterval(function() {
  if ($('.widgetSellingPlanWrapper').length > 0) {
    clearInterval(intervalId);
    $('.widgetSellingPlanWrapper .appstle_input_wrapper:nth-of-type(2)').on('click',function(){
        console.log('usama')
        $('.purchase-main').addClass('subsave');
        if($('.purchase-main').hasClass('subsave')) {
            var orgPrice = parseFloat($('.purchase-main.subsave .save-10 .price-custom').text().split('$')[1]);
            var disPrice = parseFloat($('.purchase-main.subsave .save-10 .price-custom').text().split('$')[1]) * 25 / 100;
            var price = orgPrice - disPrice;
            $('.purchase-main.subsave .save-10 .price-custom').attr('data-sub', price.toFixed(2));
        }
    })
  }
}, 1000);
  

    $(window).on('load',function(){
      console.log('luffy');
      setTimeout(function() {
        $('.rc_popup').addClass('none');
        $('.rc-option__onetime').on('click',function(){
            $('.rc_popup').addClass('none');
        })
        
        $('.rc-option__subsave').on('click',function(){
            $('.rc_popup').removeClass('none');
        })
      }, 1000)
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-review-slider"]) return;
  try {
    
  var swiper = new Swiper(".static-reviews__slider", {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  } catch(e) { console.error(e); }
})();
})();
